import * as yup from 'yup';

const schema = yup.object().shape({
  reason: yup.string('').required('This field is required'),
});

export default schema;
